import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectWithoutProperties.js";
import n from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectSpread2.js";
import "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/primitives/icon.tsx
var i = [
	"name",
	"size",
	"className",
	"color",
	"style"
], a = {
	"alert-circle": "fa-regular fa-circle-exclamation",
	"alert-octagon": "fa-regular fa-octagon-exclamation",
	"info-circle": "fa-regular fa-circle-info",
	"help-circle": "fa-regular fa-circle-question",
	"check-circle-broken": "fa-regular fa-circle-check",
	"x-circle": "fa-regular fa-circle-xmark",
	check: "fa-regular fa-check",
	plus: "fa-regular fa-plus",
	"x-close": "fa-regular fa-xmark",
	xmark: "fa-regular fa-xmark",
	share: "fa-regular fa-share",
	"share-03": "fa-regular fa-share-nodes",
	"lock-01": "fa-regular fa-lock",
	trash: "fa-regular fa-trash",
	pen: "fa-regular fa-pen",
	download: "fa-regular fa-download",
	search: "fa-regular fa-search",
	"chevron-down": "fa-regular fa-chevron-down",
	"chevron-right": "fa-regular fa-chevron-right",
	"chevrons-right": "fa-regular fa-chevrons-right",
	"chevron-up": "fa-regular fa-chevron-up",
	"arrow-left": "fa-regular fa-arrow-left",
	"arrow-right": "fa-regular fa-arrow-right",
	home: "fa-regular fa-house",
	calendar: "fa-regular fa-calendar",
	clock: "fa-regular fa-clock",
	file: "fa-regular fa-file",
	image: "fa-regular fa-image",
	"image-01": "fa-regular fa-image",
	"globe-04": "fa-regular fa-globe",
	"link-external-01": "fa-regular fa-arrow-up-right-from-square",
	lightbulb: "fa-regular fa-lightbulb",
	"brain-circuit": "fa-regular fa-brain-circuit",
	"annotation-dots": "fa-regular fa-message-dots",
	inbox: "fa-regular fa-inbox",
	"chart-line": "fa-regular fa-chart-line",
	insights: "fa-regular fa-chart-line",
	headphones: "fa-regular fa-headphones",
	"headphones-02": "fa-regular fa-headphones",
	"rocket-02": "fa-regular fa-rocket",
	"trend-up-01": "fa-regular fa-chart-line-up",
	"switch-horizontal-01": "fa-regular fa-repeat",
	"heart-hand": "fa-regular fa-hand-holding-heart",
	user: "fa-regular fa-user",
	"user-check-01": "fa-regular fa-user-check",
	"users-check": "fa-regular fa-user-check",
	"users-plus": "fa-regular fa-user-plus",
	bell: "fa-regular fa-bell",
	envelope: "fa-regular fa-envelope",
	gear: "fa-regular fa-gear",
	"scales-01": "fa-regular fa-scale-balanced",
	facebook: "fa-brands fa-facebook",
	instagram: "fa-brands fa-instagram",
	linkedin: "fa-brands fa-linkedin",
	pinterest: "fa-brands fa-pinterest",
	tiktok: "fa-brands fa-tiktok",
	snapchat: "fa-brands fa-snapchat",
	threads: "fa-brands fa-threads",
	youtube: "fa-brands fa-youtube",
	googlemybusiness: "fa-brands fa-google",
	"twitterx-inverted": "fa-brands fa-x-twitter",
	"upsell-rocket-blue-bg": "fa-regular fa-rocket-launch",
	"upsell-rocket-white-bg": "fa-regular fa-rocket-launch"
};
function o({ bgColor: t = "#4f31ff", color: n = "#fff", className: i }) {
	return /* @__PURE__ */ r("div", {
		"data-slot": "upsell-rocket-icon",
		className: e("w-5 h-5 rounded-full flex items-center justify-center", i),
		style: { backgroundColor: t },
		children: /* @__PURE__ */ r("i", {
			className: "fa-regular fa-rocket-launch text-[10px]",
			style: { color: n }
		})
	});
}
var s = {
	xs: "0.75rem",
	sm: "0.875rem",
	md: "1rem",
	lg: "1.125rem",
	xl: "1.25rem"
}, c = (e) => typeof e == "string" && e in s;
function l(o) {
	let { name: l, size: u = "md", className: d, color: f, style: p } = o, m = t(o, i), h = a[l] || `fa-regular fa-${l}`, g = c(u) ? s[u] : typeof u == "number" || /^\d+$/.test(u) ? Number(u) : void 0;
	return /* @__PURE__ */ r("i", n({
		"data-slot": "icon",
		className: e(h, d),
		style: n(n(n({}, p), f ? { color: f } : {}), g === void 0 ? {} : { fontSize: g })
	}, m));
}
//#endregion
export { l as Icon, o as UpsellRocketIcon, a as iconRegistry };

//# sourceMappingURL=icon.js.map